import { render, staticRenderFns } from "./otherProduct.vue?vue&type=template&id=59dd631a&scoped=true&"
import script from "./otherProduct.vue?vue&type=script&lang=ts&"
export * from "./otherProduct.vue?vue&type=script&lang=ts&"
import style0 from "./otherProduct.vue?vue&type=style&index=0&id=59dd631a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd631a",
  null
  
)

export default component.exports